import React from "react";
import "./Datenschutz.css";

function Datenschutz() {
  return (
    <section className="datenschutz-section">
      <h2>Datenschutzerklärung</h2>
      <h3>Allgemeiner Hinweis</h3>
      <p>
        Diese Datenschutzerklärung informiert dich darüber, welche
        personenbezogenen Daten beim Besuch der Website
        https://streamplan.sarahnokumo.de/ verarbeitet werden. Der Schutz deiner
        Daten ist mir wichtig, und ich verarbeite sie gemäß den geltenden
        Datenschutzvorschriften, insbesondere der Datenschutz-Grundverordnung
        (DSGVO).
      </p>
      <h3>Verantwortliche Stelle</h3>
      <p>Verantwortlich für die Datenverarbeitung auf dieser Website ist:</p>
      <p>
        EmeraldHost UG (haftungsbeschränkt)
        <br />
        c/o Sarahnokumo / onenet Management
        <br />
        Kurfürstenstr. 10
        <br />
        50678 Köln
        <br />
        Deutschland
        <br />
        info@onenet.gg
      </p>
      <h3>Zugriffsdaten und Server-Logs:</h3>
      <p>
        Beim Aufruf dieser Website werden durch den Hosting-Anbieter automatisch
        Informationen erfasst, die dein Browser übermittelt. Diese Daten werden
        ausschließlich zur technischen Überwachung und Optimierung der Website
        verwendet und nicht mit anderen Datenquellen zusammengeführt. Eine
        personenbezogene Auswertung findet nicht statt. Die Server-Logs werden
        nach einer definierten Frist automatisch gelöscht.
      </p>
      <h3>Kontaktaufnahme:</h3>
      <p>
        Wenn du mir per E-Mail oder über andere Wege kontaktierst, werden die
        von dir übermittelten Daten (z. B. Name, E-Mail-Adresse) gespeichert, um
        deine Anfrage zu bearbeiten. Diese Daten gebe ich nicht ohne deine
        Einwilligung weiter.
      </p>
      <h3>Deine Rechte:</h3>
      <p>
        Du hast jederzeit das Recht, Auskunft über die personenbezogenen Daten
        zu erhalten, die bei uns gespeichert sind. Ebenso hast du das Recht auf
        Berichtigung, Einschränkung, Sperrung oder – abgesehen von gesetzlich
        vorgeschriebenen Aufbewahrungsfristen – Löschung deiner Daten. Wenn du
        Fragen zum Thema Datenschutz oder zu deinen gespeicherten Daten hast,
        kannst du dich jederzeit an uns wenden.
      </p>
      <h3>Änderungen dieser Datenschutzerklärung:</h3>
      <p>
        Ich behalte mir vor, diese Datenschutzerklärung bei Bedarf anzupassen,
        z. B. bei rechtlichen Änderungen oder bei Erweiterungen der Website. Die
        jeweils aktuelle Version findest du stets auf dieser Seite.
      </p>
    </section>
  );
}

export default Datenschutz;
